<template>
  <section class="manage posire" :class="{
      collspase: menuCollapse,
    }">
    <qx-left-menu class="menuBox">
      <!-- 顶部title -->
      <h1 class="title">
<!--        <router-link to="/manage/index/workspace">-->
<!--          <img src="~images/logo.png"  style="width:8rem"/>-->
<!--        </router-link>-->
        <router-link :to="DEFAULT_HOME_PATH">
          <img src="~images/logo.png" class="sidebar-logo" />
        </router-link>
      </h1>
      <!-- 顶部title end -->
    </qx-left-menu>
    <section v-qx-full-h class="rightSide" :class="$route.meta.theme">
      <qx-header-right :theme="$route.meta.theme" :listData="headerListData" />
      <qx-tab-menu />
      <section class="content" id="manageContent" :style="`height: ${contentHeight || 'auto'}`">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
        <!-- <keep-alive>
          <router-view />
        </keep-alive>-->
      </section>
    </section>
  </section>
</template>

<script>
import {
  mapState,
} from 'vuex';
import {
  getCarList,
} from 'api/user';
import { getElementHeight } from '@qx/utils';
import DEFAULT_HOME_PATH from '@/router/defaultHome';
export default {
  data () {
    return {
      DEFAULT_HOME_PATH,
      contentHeight: 0,
      headerListData: {
        dropList: [
          {
            label: '个人信息',
            handleClick: () => {
              this.jump({
                label: '员工详情',
                url: `/manage/system/jurisdiction/worker/detail?id=${this.userInfo.staffTFInfo.userId}`,
              });
            },
          },
          {
            label: '我的账户',
            handleClick: () => {
              this.jump({
                label: '我的账户',
                url: '/manage/other/myAccount',
              });
            },
          },
          {
            label: '银行卡管理',
            handleClick: () => {
              this.jump({
                label: '银行卡信息',
                url: `/manage/other/bankcard?userId=${this.userInfo.staffTFInfo.userId}`,
                full: true,
              });
            },
          },
          {
            label: '修改登录密码',
            handleClick: () => {
              this.jump({
                label: '修改登录密码',
                url: '/manage/other/changePsw',
              });
            },
          },
          {
            label: '更换手机号',
            handleClick: () => {
              this.jump({
                label: '更换手机号',
                url: '/manage/other/changeMobile',
              });
            },
          },
          // {
          //   label: '切换车队',
          //   handleClick: () => {
          //     this.$router.push('/home');
          //   },
          // },
        ],
      },
    };
  },
  computed: {
    showTitle () {
      if (this.title) {
        return this.title;
      } else if (this.$route.meta && this.$route.meta.title) {
        return this.$route.meta.title;
      } else if (this.activeMenu) {
        return this.activeMenu.label;
      } else {
        return '概览';
      }
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
      activeMenu: (state) => state.user.activeMenu, // 选中的菜单
      title: (state) => state.user.title, // 标题
      menuCollapse: (state) => state.user.menuCollapse, // 菜单展开收起
    }),
  },
  methods: {
    getElementHeight () {
      this.contentHeight = getElementHeight('manageContent', -5);
    },
  },
  async mounted () {
    const resCardList = await getCarList();
    if (!resCardList.failed) {
      if (resCardList.items && resCardList.items.length > 1) {
        this.headerListData.dropList.push({
          label: '切换车队',
          handleClick: () => {
            this.$router.push('/home');
          },
        });
      }
    }
    this.getElementHeight();
    window.addEventListener('resize', this.getElementHeight);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getElementHeight);
  },
};
</script>

<style scoped lang="scss">
@import 'styles/config.scss';
.manage.collspase {
  padding-left: 64px;

  .menuBox {
    .title {
      img {
        width: 44px !important;
      }
    }
  }
}

.manage {
  padding-left: 192px;
  min-height: 100%;
  overflow: hidden;
  background: #F8F9FA;

  .menuBox {
    background: $deep-black !important;
    box-shadow: 8px 0 24px rgba(17, 17, 17, 0.10);

    .title {
      height: 64px;
      line-height: 64px;
      box-sizing: border-box;
      text-align: center;
      background: linear-gradient(180deg, #111111 0%, #171717 100%);
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);

      img {
        width: 70px;
        filter: drop-shadow(0 6px 14px rgba(249, 115, 22, 0.16));
      }

      .divide {
        margin: 0 24px;
        opacity: 0.24;
      }

      .projectName {
        color: rgba(255, 255, 255, 0.72);
        font-weight: 700;
        letter-spacing: 0.02em;
      }
    }

    .indexBtn {
      width: 160px;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: $radius-default;
      margin-bottom: 32px;
      padding: 0;
      color: rgba(255, 255, 255, 0.62);
      transition: all .18s ease;

      span {
        color: rgba(255, 255, 255, 0.62);
      }

      .iconfont {
        margin-right: 7px;
      }

      .label {
        top: -1px;
      }
    }

    .indexBtn:hover,
    .indexBtn.active {
      background: $primary;
      border-color: $primary;
      color: #fff;
      box-shadow: 0 10px 24px rgba(249, 115, 22, 0.24);

      span {
        color: #fff;
      }
    }
  }

  .rightSide {
    min-height: 100vh;
    background: linear-gradient(180deg, #F8F9FA 0%, #F3F4F6 100%);

    .title {
      height: 28px;
      line-height: 28px;
      font-size: 24px;
      font-weight: 700;
      color: $text-main;
      padding: 24px 24px 16px;
      letter-spacing: -0.02em;
    }
  }

  .rightSide.active {
    background-image:
      linear-gradient(180deg, rgba(17, 17, 17, 0.72) 0%, rgba(17, 17, 17, 0) 240px),
      url('~images/manageBg.png');
    background-size: 100% auto;
    background-repeat: no-repeat;

    .title {
      color: #fff;
    }
  }

  .content {
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }

  .footer {
    bottom: 0;
    left: 0;
    width: 100%;
    padding-left: 192px;
    box-sizing: border-box;
  }
}

// qx component style bridge: the qx components are imported from @qx,
// so we theme common deep descendants here without changing component logic.
.manage ::v-deep .el-menu,
.manage ::v-deep .el-menu--inline {
  background: $deep-black !important;
  border-right: none;
}

.manage ::v-deep .el-menu-item,
.manage ::v-deep .el-submenu__title {
  color: rgba(255, 255, 255, 0.68) !important;
  font-weight: 600;
  border-radius: $radius-default;
  margin: 2px 10px;
  height: 42px;
  line-height: 42px;
}

.manage ::v-deep .el-menu-item:hover,
.manage ::v-deep .el-submenu__title:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #fff !important;
}

.manage ::v-deep .el-menu-item.is-active {
  background: #1A1A1A !important;
  color: #fff !important;
  box-shadow: inset 3px 0 0 $primary;
}

.manage ::v-deep .el-menu-item.is-active i,
.manage ::v-deep .el-menu-item:hover i,
.manage ::v-deep .el-submenu__title:hover i {
  color: $primary !important;
}

.manage ::v-deep .el-header,
.manage ::v-deep .header,
.manage ::v-deep .headerBox {
  background: rgba(255, 255, 255, 0.92) !important;
  border-bottom: 1px solid $border-subtle;
  box-shadow: 0 4px 12px rgba(17, 24, 39, 0.03);
  backdrop-filter: blur(10px);
}

.manage ::v-deep .tab-menu,
.manage ::v-deep .tabMenu,
.manage ::v-deep .tabsBox {
  background: #fff;
  border-bottom: 1px solid $border-subtle;
  box-shadow: 0 2px 10px rgba(17, 24, 39, 0.02);
}
</style>
